













import {
    Vue, Component, Prop, PropSync, Mixins, Watch,
} from 'vue-property-decorator'

@Component
export default class SelectAllOption extends Vue {
    $refs!: {
        option: any
    }

    @Prop({
        default() {
            return []
        },
    }) model!: any[]

    @Prop({
        default() {
            return []
        },
    }) list!: any[]

    @Prop({
        default() {
            return []
        },
    }) disableList!: any[]

    @Prop({default: ''}) valueKey!: string

    @Prop({
        default() {
            return this.$t1('select_all')
        },
    }) selectTitle!: any

    selectAll() {
        let val: any[] = []
        let disableSelected: any[] = this.model.filter(v => this.disableList.includes(v))     // 不要改动已选择的禁用的
        if (this.model.length < (this.list.length - this.disableList.length + disableSelected.length)) {
            this.list.forEach(v => {
                let value = this.valueKey ? v[this.valueKey] : v
                if (!this.disableList.includes(value)) {
                    val.push(value)
                }
            })
        }
        if (val.length) {
            this.model.splice(0, this.model.length, ...[...val, ...disableSelected])
        } else {
            this.model.splice(0, this.model.length, ...disableSelected)
        }

        this.$emit('change')
        let option = this.$refs.option
        if (option.select) {
            option.select.dispatch('ElFormItem', 'el.form.change', this.model);
        }
    }
}
